import { ArrowForward } from "@mui/icons-material";
import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { sendQuery } from "../../../modules/traceability";
const defaultData = {
  name: "",
  phone: "",
  email: "",
  reason: "",
  application: "",
}
const BannerForm = () => {
  const [formData, setFormData] = useState(defaultData);

  const handleChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      await sendQuery(formData);
      setFormData(defaultData)
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Container id="banner-form" className="py-5">
      <Row>
        <Col className="d-md-flex justify-content-center">
          <Form className="banner-form p-2 p-md-4 mb-2" onSubmit={handleSubmit}>
            <Container fluid>
              <Row>
                <Col>
                  <h6 className="form-heading">Get Started now for Free</h6>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label htmlFor="name">Name</Form.Label>
                  <Form.Control
                    onChange={(event) =>
                      handleChange("name", event.target.value)
                    }
                    required
                    value={formData.name}
                    id="name"
                    type="text"
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label htmlFor="phone">Phone No</Form.Label>
                  <Form.Control
                    onChange={(event) =>
                      handleChange("phone", event.target.value)
                    }
                    value={formData.phone}
                    id="phone"
                    type="tel"
                    maxLength={10}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label htmlFor="email">Email</Form.Label>
                  <Form.Control
                    required
                    onChange={(event) =>
                      handleChange("email", event.target.value)
                    }
                    value={formData.email}
                    id="email"
                    type="email"
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label htmlFor="reason">
                    What is your primary reason you are here?
                  </Form.Label>
                  <Form.Select
                    className="mt-4"
                    onChange={(event) =>
                      handleChange("reason", event.target.value)
                    }
                    value={formData.reason}
                    aria-label="What is your primary reason you are here?"
                  >
                    <option value="" disabled>
                      Please select
                    </option>
                    <option value="Looking for a test intelligence platform">Looking for a test intelligence platform</option>
                    <option value="Identifying an alternative for Zephyr or TestRail">Identifying an alternative for Zephyr or TestRail</option>
                  </Form.Select>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label htmlFor="application">
                    Which application are you looking to test?
                  </Form.Label>
                  <Form.Select
                    className="mt-4"
                    onChange={(event) =>
                      handleChange("application", event.target.value)
                    }
                    value={formData.application}
                    aria-label="Which application are you looking to test?"
                  >
                    <option value="" disabled>
                      Please select
                    </option>
                    <option value="Mobile first">Mobile first</option>
                    <option value="Web only">Web only</option>
                    <option value="Web & Mobile">Web & Mobile</option>
                    <option value="Backend API or Microservices">Backend API or Microservices</option>
                    <option value="Data & AI">Data & AI</option>
                    <option value="Cloud Infrastructure">Cloud Infrastructure</option>
                    <option value="SaaS Software">SaaS Software</option>
                  </Form.Select>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col>
                  <Button type="submit">
                    Submit Now <ArrowForward fontSize="18px" />
                  </Button>
                </Col>
              </Row>
            </Container>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default BannerForm;
